const initalState = null

const userSitesReducer = (state = initalState, action) => {
	const {type, data} = action

	switch (type) {
		case "ADD_USER_SITE":
			return data
		
		default:
			return state
	}
}

const userModulesReducer = (state = initalState, action) => {
	const {type, data} = action

	switch (type) {
		case "ADD_USER_MODULE":
			return data
		
		default:
			return state
	}
}


export {
	userSitesReducer,
	userModulesReducer,
}